import React from "react";
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import Paper from "@material-ui/core/Paper";
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from "@material-ui/core/TableContainer";
import Box from "@material-ui/core/Box";

export default class ComponentToPrint extends React.Component {

    render() {
        const newCol = ["Session 1", "Session 2", "Session 3"]
        const reportData = this.props.reportData;
        const searchData = this.props.searchData;
        const totalValues = this.props.totalValues;
        const summeryData = this.props.summeryData;

        const options = {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        };
        return (
            <div className="pl-2 pr-2">
                <h3><center><u>Tipping Details Report</u></center></h3>
                <div className="row pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Operation Entity: </b> {searchData.estate}</div>
                    <div className="col"><b>Collection Point: </b> {searchData.division}</div>
                    <div className="col"><b>From Date: </b> {searchData.fromDate}</div>
                    <div className="col"><b>To Date: </b> {searchData.toDate}</div>
                </div>

                <div>
                    <div className="row">
                        <div className="col-md-12">
                            <div>
                                <Box display="flex" justifyContent="flex-end" p={2}>
                                    <TableContainer component={Paper}>
                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow style={{ border: "2px solid black" }}>
                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Registration Number</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Employee Name</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Date</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Session 1</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Session 2</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Session 3</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Total(Kg)</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody >
                                                {reportData.map((row, i) => (
                                                    <TableRow key={i} style={{ border: "2px solid black" }}>
                                                        <TableCell component="th" scope="row" align="left" style={{ border: "2px solid black" }}>{row.registrationNumber}</TableCell>
                                                        <TableCell component="th" scope="row" align="left" style={{ border: "2px solid black" }}>{row.firstName}</TableCell>
                                                        <TableCell component="th" scope="row" align="center" style={{ border: "2px solid black" }}>{row.date.split('T')[0]}</TableCell>
                                                        {newCol.map((roww, index) => {
                                                            const found = row[roww];
                                                            return (
                                                                <TableCell align="right" key={index} style={{ border: "2px solid black" }}>
                                                                    {found !== undefined ? parseFloat(found).toFixed(2) : ' - '}
                                                                </TableCell>
                                                            )
                                                        })}
                                                        <TableCell component="th" scope="row" align="right" style={{ border: "2px solid black" }}>{row.total.toFixed(2)}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                            <TableBody>
                                                <TableRow style={{ border: "2px solid black" }}>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }} colSpan={3}>
                                                        Total
                                                    </TableCell>
                                                    {newCol.map((item) => {
                                                        const found = summeryData.find(x => x.name == item);
                                                        if (found) {
                                                            return (
                                                                <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} align="right">
                                                                    {parseFloat(found.value).toFixed(2)}
                                                                </TableCell>
                                                            )
                                                        }
                                                        else {
                                                            return (
                                                                <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} align="right">
                                                                </TableCell>
                                                            )
                                                        }
                                                    })}
                                                    <TableCell align="right" style={{ fontWeight: "bold" }} >
                                                        {totalValues.alltotal == 0 ? '' : parseFloat(totalValues.alltotal).toLocaleString('en-US', options)}
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
